import { CrudModel } from "./_crud";

export class MediaAppModel extends CrudModel {
	constructor() {
		super("app/media");
	}
}

export default new MediaAppModel();
